import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";

const VID_KEY = "ko_vid";
const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));

function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); }
  return v;
}

export default function VisitorTracker() {
  const loc = useLocation();
  const ev = useRef({ id: null, scroll: 0 });

  useEffect(() => {
    if (loc.pathname.startsWith("/admin")) return;
    const eventId = uuid();
    ev.current = { id: eventId, scroll: 0 };

    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitor_id: getVisitorId(), path: loc.pathname, referrer: document.referrer || "", event_id: eventId }),
      keepalive: true,
    }).catch(() => {});

    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const pct = h > 0 ? Math.min(100, Math.round((window.scrollY / h) * 100)) : 100;
      if (pct > ev.current.scroll) ev.current.scroll = pct;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    const flush = () => {
      const { id, scroll } = ev.current;
      if (!id) return;
      const body = JSON.stringify({ event_id: id, scroll });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/track/scroll`, new Blob([body], { type: "application/json" }));
      } else {
        fetch(`${API}/track/scroll`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
      }
    };
    window.addEventListener("beforeunload", flush);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("beforeunload", flush);
      flush();
    };
  }, [loc.pathname]);

  return null;
}
